/**
 * Tour guide — Section Parc informatique
 */

export const computersTour = [
  {
    target: '[data-tour="parc-barre"]',
    title: 'Recherche et filtres',
    content: 'Recherchez un poste par nom, société, utilisateur, IP ou numéro de série. Filtres : Tous, Non affectés, Critiques, Hors ligne, Multi-sources.',
    position: 'bottom',
  },
  {
    target: '[data-tour="parc-liste"]',
    title: 'Liste des postes',
    content: 'Un clic sur un poste ouvre sa fiche : vue d\'ensemble, matériel, logiciels, sécurité, sauvegardes, accès distant, tickets, historique…',
    position: 'top',
  },
  {
    target: '[data-tour="parc-refresh"]',
    title: 'Actualiser',
    content: 'Relit la liste immédiatement. La synchro ESET tourne toute seule toutes les 30 min.',
    position: 'bottom',
  },
];

export const sauvegardesTour = [
  {
    target: '[data-tour="acronis-tabs"]',
    title: 'Navigation Acronis',
    content: '5 onglets : Tableau de bord (vue d\'ensemble), Agents (appareils), Alertes (problèmes), Historique (30 jours) et Plans (protection).',
    position: 'bottom',
  },
  {
    target: '[data-tour="acronis-stats"]',
    title: 'Indicateurs clés',
    content: 'Agents en ligne/hors ligne, alertes critiques et espace de stockage utilisé par rapport au quota.',
    position: 'bottom',
  },
];
